import { useQuery } from '@tanstack/react-query';
import { cacheAdminApi } from '../api/cacheAdminApi';
import type { CacheKeysFilter } from '../types/cacheAdmin';

/**
 * GET /api/eraf/cache-admin/caches/{name}/keys — 키스페이스 페이징 (CACHE_READ)
 * queryKey: ['cache-admin', 'keys', name, filters]
 */
export function useCacheKeys(name: string | null, filters: CacheKeysFilter) {
  return useQuery({
    queryKey: ['cache-admin', 'keys', name, filters],
    queryFn: () =>
      cacheAdminApi.getCacheKeys({
        name: name!,
        keyword: filters.keyword || undefined,
        page: filters.page ?? 0,
        size: filters.size ?? 50,
      }),
    enabled: !!name,
    staleTime: 15_000,
  });
}
